<script setup>
import { ref, computed, watch, defineAsyncComponent } from 'vue'
import { useGlobalStore } from '@stores/global.js'
import { useSeoMeta } from '@unhead/vue'
import { useRoute } from 'vue-router'
import { format } from '@formkit/tempo'
import markdownit from 'markdown-it'
import Tag from '@components/global/Tag.vue'
import Loading from '@components/global/Loading.vue'
import Arrow from '@components/global/accents/Arrow.vue'

const global = useGlobalStore()
const route = useRoute()
const md = markdownit()
const loading = ref(true)
const policy = ref({})
const requestPolicy = ref(null)
const slug = computed(() => route.params.slug)

function cancelPolicy() {
	if (requestPolicy.value) requestPolicy.value.cancel()
}
function getPolicy() {
	loading.value = true
	policy.value = {}
	cancelPolicy()
	let axiosSource = axios.CancelToken.source()
	requestPolicy.value = { cancel: axiosSource.cancel }
	axios
		.get(`/api/policy/${slug.value}`, {
			cancelToken: axiosSource.token,
		})
		.then((a) => {
			loading.value = false
			policy.value = a.data
		})
		.catch((e) => {})
}
getPolicy()

const content = computed(() => {
	return policy.value.content ? md.render(policy.value.content) : null
})

watch(slug, async () => {
	getPolicy()
})

useSeoMeta({
	title: () => global.pages.find((page) => page.path === '/')?.title,
	description: () => global.pages.find((page) => page.path === '/')?.description,
	image: () => global.pages.find((page) => page.path === '/')?.image,
})
</script>

<template>
	<Loading v-if="loading" />
	<main v-else>
		<section class="bg-black bg-repeat md:bg-crowns-off-black md:bg-[url('https://cdn.papercrowns.com/website/images/backgrounds/papercrowns-plaid.svg')]">
			<div class="container">
				<div class="grid-cols-3 xl:grid">
					<div class="col-span-2 col-start-2 flex flex-col gap-10 bg-black py-24 md:px-10 lg:px-16">
						<div class="flex flex-col items-center gap-5 sm:flex-row lg:gap-10">
							<img class="h-24 w-auto md:h-32 lg:h-44" src="https://cdn.papercrowns.com/website/images/elements/etches/legal-scroll.svg" alt="Legal Scroll" />
							<div class="flex flex-col gap-1">
								<h4 class="hidden md:block">{{ policy.title }}</h4>
								<h5 class="block md:hidden">{{ policy.title }}</h5>
								<p>Last updated: {{ format(policy.policy_updated_at, 'MMMM D, YYYY') }}</p>
							</div>
						</div>
						<div class="markdown light" v-html="content"></div>
					</div>
				</div>
			</div>
		</section>
	</main>
</template>
